/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2, VisuallyHidden } from '@coursera/cds-core';

import _t from 'i18n!nls/front-page';

const styles = {
  jobsAvailableInfo: css`
    margin-top: calc(var(--cds-spacing-50) / 2);
  `,
};

type JobsAvailableInfoProps = {
  numJobsAvailable: number;
};

const JobsAvailableInfo = ({ numJobsAvailable }: JobsAvailableInfoProps) => (
  <Typography2
    data-testid="jobs-available"
    variant="bodySecondary"
    color="supportText"
    component="p"
    css={styles.jobsAvailableInfo}
  >
    {/* Screen reader only */}
    <VisuallyHidden component="span">
      <FormattedMessage
        message={_t('This role has approximately {jobsAvailable} jobs available ¹.')}
        jobsAvailable={<FormattedNumber value={numJobsAvailable} />}
      />
    </VisuallyHidden>
    {/* Display purposes only, not announced by screen reader (handled above) */}
    <span aria-hidden="true">
      <FormattedMessage
        message={_t('{jobsAvailable} jobs available ¹')}
        jobsAvailable={
          <strong>
            <FormattedNumber value={numJobsAvailable} />
          </strong>
        }
      />
    </span>
  </Typography2>
);

export default JobsAvailableInfo;
